import { AccountInfo } from '@azure/msal-browser';
import { SeuOfferUser } from '@seu-types';

export function getUserInitialsFromAccountInfo(
  accountInfo: AccountInfo
): string {
  if (!accountInfo.name) {
    return '';
  }
  const nameArray = accountInfo.name
    .split('(')[0]
    .trim()
    .split(' ')
    .filter((name) => name.length > 0);
  if (nameArray.length === 2) {
    return `${nameArray[0][0].toUpperCase()}${nameArray[1][0].toUpperCase()}`;
  }

  if (nameArray.length > 2) {
    return `${nameArray[0][0].toUpperCase()}${nameArray[nameArray.length - 1][0].toUpperCase()}`;
  }
  return '';
}

export function getInitialsFromOfferUser(user: SeuOfferUser): string {
  if (!user.firstName || !user.lastName) {
    return '';
  }
  return `${user.firstName[0].toUpperCase()}${user.lastName[0].toUpperCase()}`;
}
